import { DSEmailCard } from 'shared-definitions/types'
import styles from './MailBlock.module.css'

interface MailBlockProps {
  card: DSEmailCard
}

const MailBlock: React.VFC<MailBlockProps> = ({ card }) => (
  <a className={styles.container} href={`mailto:${card.email}`}>
    <h4 className={styles.title}>{card.text}</h4>
    <div className={styles.mail}>{card.email}</div>
  </a>
)

export default MailBlock
